import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const BecomeSeller = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    document_type: 'PAN',
    document_number: '',
    bank_account_number: '',
    bank_ifsc: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const initPayment = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      // 1. Create fee order
      const res = await fetch('/api/register/fee/create', { method: 'POST' });
      const order = await res.json();
      
      if (!res.ok) throw new Error(order.message || 'Failed to create payment');

      // 2. Open Razorpay
      const options = {
        key: 'rzp_live_SmVeN1p4Ymvnh2', // Public key
        amount: order.amount,
        currency: order.currency,
        name: 'MitoForge',
        description: 'Seller Registration KYC Fee',
        order_id: order.id,
        handler: async (response) => {
          try {
            // 3. Register user on backend with payment details
            const registerRes = await fetch('/api/register/seller', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                ...formData,
                razorpay_order_id: response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature
              })
            });
            
            const data = await registerRes.json();
            if (!registerRes.ok) throw new Error(data.message);
            
            alert(`Registration successful! Your code is ${data.affiliate_code}. Please log in.`);
            navigate('/login');
          } catch (err) {
            setError(err.message);
            setLoading(false);
          }
        },
        prefill: {
          name: formData.name,
          email: formData.email
        },
        theme: { color: '#000000' }
      };
      
      const rzp = new window.Razorpay(options);
      rzp.on('payment.failed', function (response){
        setError(response.error.description);
        setLoading(false);
      });
      rzp.open();
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#000', paddingTop: '80px', paddingBottom: '40px' }}>
      <div style={{ background: '#111', padding: '40px', borderRadius: '12px', border: '1px solid #333', width: '100%', maxWidth: '500px' }}>
        <h2 style={{ color: '#fff', marginBottom: '16px', textAlign: 'center' }}>Become an Affiliate Seller</h2>
        <p style={{ color: '#888', textAlign: 'center', marginBottom: '32px', fontSize: '0.9rem', lineHeight: 1.5 }}>
          Join the MitoForge affiliate program. Earn a 10% commission on every sale made with your unique code. 
          A one-time ₹50 KYC verification fee applies.
        </p>
        
        {error && <div style={{ color: '#ff4444', marginBottom: '16px', fontSize: '0.9rem', textAlign: 'center' }}>{error}</div>}
        
        <form onSubmit={initPayment}>
          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', color: '#888', marginBottom: '8px', fontSize: '0.9rem' }}>Full Name</label>
            <input type="text" name="name" value={formData.name} onChange={handleInputChange} style={inputStyle} required />
          </div>
          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', color: '#888', marginBottom: '8px', fontSize: '0.9rem' }}>Email</label>
            <input type="email" name="email" value={formData.email} onChange={handleInputChange} style={inputStyle} required />
          </div>
          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', color: '#888', marginBottom: '8px', fontSize: '0.9rem' }}>Password</label>
            <input type="password" name="password" value={formData.password} onChange={handleInputChange} style={inputStyle} required minLength="6" />
          </div>
          
          <div style={{ display: 'flex', gap: '16px', marginBottom: '24px' }}>
            <div style={{ flex: 1 }}>
              <label style={{ display: 'block', color: '#888', marginBottom: '8px', fontSize: '0.9rem' }}>ID Type</label>
              <select name="document_type" value={formData.document_type} onChange={handleInputChange} style={inputStyle}>
                <option value="PAN">PAN Card</option>
                <option value="Aadhaar">Aadhaar Card</option>
              </select>
            </div>
            <div style={{ flex: 2 }}>
              <label style={{ display: 'block', color: '#888', marginBottom: '8px', fontSize: '0.9rem' }}>Document Number</label>
              <input type="text" name="document_number" value={formData.document_number} onChange={handleInputChange} style={inputStyle} required />
            </div>
          </div>

          <div style={{ display: 'flex', gap: '16px', marginBottom: '24px', borderTop: '1px solid #333', paddingTop: '24px' }}>
            <div style={{ flex: 2 }}>
              <label style={{ display: 'block', color: '#888', marginBottom: '8px', fontSize: '0.9rem' }}>Bank Account Number</label>
              <input type="text" name="bank_account_number" value={formData.bank_account_number} onChange={handleInputChange} style={inputStyle} required />
            </div>
            <div style={{ flex: 1 }}>
              <label style={{ display: 'block', color: '#888', marginBottom: '8px', fontSize: '0.9rem' }}>IFSC Code</label>
              <input type="text" name="bank_ifsc" value={formData.bank_ifsc} onChange={(e) => setFormData({...formData, bank_ifsc: e.target.value.toUpperCase()})} style={inputStyle} required maxLength={11} placeholder="e.g. HDFC0001234" />
            </div>
          </div>

          <button type="submit" disabled={loading} style={{ width: '100%', padding: '14px', background: '#fff', color: '#000', border: 'none', borderRadius: '4px', fontWeight: 'bold', cursor: loading ? 'not-allowed' : 'pointer' }}>
            {loading ? 'Processing...' : 'Pay ₹50 & Verify KYC'}
          </button>
        </form>
      </div>
    </div>
  );
};

const inputStyle = { width: '100%', padding: '12px', background: '#000', border: '1px solid #333', color: '#fff', borderRadius: '4px' };

export default BecomeSeller;
